import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/imagen-no-disponible.png")